import axiosInstanceV2 from 'utils/InstanceAxios/InstanceAxiosV2';
import { Types } from '../reducers/fileSystem';
import { fileSystem } from 'utils/consts/serverRoutes.js';
import { toast } from 'react-toastify';
import errorMessages from 'utils/consts/errors';

//Synchronous

//Asynchronous
export const listDirectory = (collection_id, item_id) => {
	return (dispatch) => {
		dispatch({
			type: Types.SET_LOADING,
		});

		axiosInstanceV2.get(fileSystem.directory(`/${collection_id}`, `/${item_id ?? ''}`))
			.then((response) => {
				dispatch({
					type: Types.LIST_DIRECTORY,
					payload: response.data,
				})
			})
			.catch((err) => {
				console.log(err)
				dispatch({
					type: Types.LIST_DIRECTORY,
					payload: [],
				});
			})
	}
}

export const createDirectory = (collection_id, path) => {
	return dispatch => {
		dispatch({
			type: Types.SET_LOADING,
		});

		axiosInstanceV2.post(fileSystem.directory(collection_id), { path })
			.then(response => {
				dispatch({
					type: Types.CREATE_DIRECTORY,
					payload: response.data,
				})
			})
			.catch((err) => {
				console.log(err);
				dispatch({
					type: Types.CREATE_DIRECTORY,
					payload: null,
				});
			});
	}
}

export const renameDirectory = (collection_id, item_id, destination) => {
	return dispatch => {
		axiosInstanceV2.put(fileSystem.directory(collection_id, item_id), { destination })
			.then(response => {
				dispatch({
					type: Types.RENAME_DIRECTORY,
					payload: response.data,
				});
			})
			.catch((err) => {
				console.log(err);
				dispatch({
					type: Types.RENAME_DIRECTORY,
					payload: null,
				});
			})
	}
}

export const deleteDirectory = (collection_id, item_id) => {
	return (dispatch, getState) => {
		axiosInstanceV2.delete(fileSystem.directory(collection_id, item_id))
			.then(response => {
				dispatch({
					type: Types.DELETE_DIRECTORY,
					payload: response.data,
				});
			})
			.catch((err) => {
				const { directory } = getState();
				dispatch({
					type: Types.DELETE_DIRECTORY,
					payload: directory,
				});
        const message = (err.response?.data?.error?.message || err.response?.data?.error || err.response?.data) || err.message;
        const errorMessage = errorMessages[message] || message;
				toast.error(`Erro: ${errorMessage}`, { autoClose: 10000 });
			})
	}
}

export const uploadFile = (collection_id, item_id, file, callback) => {
	return (dispatch, getState) => {
		axiosInstanceV2.post(fileSystem.file(`/${collection_id}`, `/${item_id}`), file, {
			onUploadProgress: e => {
				const progress = parseInt(Math.round((e.loaded * 100) / e.total));
				callback({ progress });
			}
		})
			.then(response => {
				const { fileSystem } = getState();
				dispatch({
					type: Types.UPLOAD_FILE,
					payload: [...(fileSystem.directory || []), `${item_id}/${response.data}`],
				});

				callback({
					uploaded: true,
					id: response.data,
				});
			})
			.catch(err => {
				dispatch({
					type: Types.UPLOAD_FILE,
					payload: null,
				});
				callback({
					error: true,
					id: err.response?.data?._id,
				});
			})
	}
}
